import { httpClient } from "../httpClient";

const apiUrl = "/api";
const STORAGE_KEY = "selectedClub"; // gleicher Key + gleiche Form wie in authProvider.ts / ClubContext.tsx

type AssignableClub = {
  id: number;
  display_name: string;
};

export async function ensureDefaultClubSelected() {
  // schon gesetzt → nichts tun
  if (localStorage.getItem(STORAGE_KEY)) return;

  const { json } = await httpClient(`${apiUrl}/users/assignable-clubs`);

  // 🔒 robust: egal was kommt, wir machen ein Array draus
  const clubs: AssignableClub[] = Array.isArray(json)
    ? json
    : Array.isArray((json as any)?.data)
    ? (json as any).data
    : [];

  // kein Club → nichts setzen
  if (clubs.length === 0) return;

  // genau ein Club → automatisch setzen
  // WICHTIG: volles Club-Objekt speichern ({id, display_name}), nicht nur die id -
  // authProvider.ts und ClubContext.tsx lesen unter demselben Key ein Objekt und
  // greifen auf club?.id zu; eine nackte Zahl liefert dort club?.id === undefined,
  // wodurch getPermissions() ohne club_id aufgerufen wird (unvollständige Rechte).
  if (clubs.length === 1) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clubs[0]));
  }
}
